module.exports = __webpack_public_path__ + "img/page7-bg-card.6dbc872f.png";